import { WithTooltip } from 'modules/common/components/WithTooltip/WithTooltip';
import { ConnectBtnFull } from './ConnectBtnFull';
import { ConnectBtnIcon } from './ConnectBtnIcon';

export interface IConnectBtnProps {
  title: string;
  subtitle?: string;
  iconSlot?: JSX.Element;
  isDisabled?: boolean;
  isLoading?: boolean;
  link?: string;
  withInstallLabel?: boolean;
  tooltip?: string;
  onClick?: () => void;
  iconOnly?: boolean;
}

const getProps = (
  link: string | undefined,
  onClick?: () => void,
): {
  component: React.ElementType;
  href?: string;
  target?: string;
  rel?: string;
  onClick?: () => void;
} =>
  link
    ? {
        component: 'a',
        href: link,
        target: '_blank',
        rel: 'noreferrer',
      }
    : {
        component: 'button',
        onClick,
      };

export function ConnectBtn({
  title,
  subtitle,
  iconSlot,
  isDisabled,
  isLoading,
  link,
  withInstallLabel,
  tooltip,
  onClick,
  iconOnly,
}: IConnectBtnProps): JSX.Element {
  const props = getProps(link, onClick);

  if (iconOnly) {
    return (
      <WithTooltip tooltip={tooltip}>
        <ConnectBtnIcon
          disabled={isDisabled}
          isLoading={isLoading}
          iconSlot={iconSlot}
          {...props}
        />
      </WithTooltip>
    );
  }

  return (
    <WithTooltip tooltip={tooltip}>
      <ConnectBtnFull
        title={title}
        subtitle={subtitle}
        isDisabled={isDisabled}
        isLoading={isLoading}
        withInstallLabel={withInstallLabel}
        iconSlot={iconSlot}
        {...props}
      />
    </WithTooltip>
  );
}
